import { gql } from 'apollo-angular';

/**
 * Schema for external partner credentials
 */
export class LinkedPartnerCredentialsSchema {
	/**
	 * All properties
	 */
	static readonly topLevelProperties = `
		internalPartnerName
		name
		contractors {
		  uid
		  eMailAddress
		  name
		  faxNumber
		  billingAddress {
			address1
			city
			zipCode
			latitude
			longitude
			country {
			  code
			  name
			}
		  }
		}
	`;

	/**
	 * Get External Partner
	 */
	static readonly linkedPartner = gql`
		query ExternalPartner($uid: String!) {
			externalpartner(uid: $uid) {
				internalPartnerName
				name
			}
		}
	`;

	/**
	 * Get external partner credentials
	 */
	static readonly linkedPartnerList = gql`
		query ExternalPartnerList {
			externalPartnerList {
				${LinkedPartnerCredentialsSchema.topLevelProperties}
			}
		}
	`;

	/**
	 * Get linked partner credentials
	 */
	static readonly setCredentials = gql`
		mutation SetCredentials($externalPartnerName: String!, $username: String, $password: String) {
			setCredentials(externalPartnerName: $externalPartnerName, username: $username, password: $password)
		}
	`;

	/**
	 * Get credentials
	 */
	static readonly getCredentials = gql`
		query GetCredentials($externalPartnerName: String!) {
			getCredentials(externalPartnerName: $externalPartnerName) {
				username
			}
		}
	`;
}
